export const STATUS_META = {
  on_track: { label: 'On track', bg: '#ecfdf5', fg: '#047857', bd: '#a7f3d0' },
  checkin_overdue: { label: 'Check-in overdue', bg: '#fffbeb', fg: '#b45309', bd: '#fde68a' },
  medicine_missed: { label: 'Medicine missed', bg: '#fff7ed', fg: '#c2410c', bd: '#fed7aa' },
  red_flag: { label: 'Red flag · self-care', bg: '#fef3c7', fg: '#92400e', bd: '#fcd34d' },
  escalated: { label: 'Escalated · urgent', bg: '#fef2f2', fg: '#b91c1c', bd: '#fca5a5' },
  closed: { label: 'Closed', bg: '#f1f5f9', fg: '#475569', bd: '#cbd5e1' },
  draft: { label: 'Draft', bg: '#f1f5f9', fg: '#475569', bd: '#cbd5e1' },
};

export const FREQ_OPTIONS = [
  ['OD', 'Once daily'], ['BD', 'Twice daily'], ['TDS', 'Three times daily'],
  ['QID', 'Four times daily'], ['HS', 'At bedtime'], ['SOS', 'Only if needed (SOS)'],
];

export const backendUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;

export const fmtIST = (iso, withDate = true) => {
  if (!iso) return '—';
  const opts = { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' };
  if (withDate) Object.assign(opts, { day: '2-digit', month: 'short' });
  return new Date(iso).toLocaleString('en-IN', opts);
};

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
};
